<div class="individual-display">
  <ng-container *appLoad="let data of load$; trackingName: 'individual-summary'">
    <!-- personal -->
    <h4>Personal</h4>

    <lds-card [isClickable]="true" (click)="edit()">
      <div class="individual-display__details">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Title"
              [text]="data.individual.name.title"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="First name"
              [text]="data.individual.name.first"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Middle name"
              [text]="data.individual.name.middle"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Last name"
              [text]="data.individual.name.last"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Known as"
              [text]="data.individual.name.preferred"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Date of birth"
              [text]="
                data.individual.birthDate | date : 'dd/MM/yyyy'
              "></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Gender"
              [text]="data.individual.gender"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Status"
              [text]="data.individual.status"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Contact type"
              [text]="data.individual.contactType"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Send marketing comms."
              [text]="
                data.individual.sendMarketingCommunications
                  | yesNoNotGiven : false
                  | titlecase
              "></app-summary-field>
          </div>
          <div
            class="col-12 col-sm-6 col-lg-3"
            *ngIf="data.individual.contactType | displayAffiliateId">
            <app-summary-field
              label="Affiliate ID"
              [text]="data.individual.nmbAffiliateId"></app-summary-field>
          </div>
        </div>
      </div>
      <div class="individual-display__action">
        <lds-icon-button icon="edit" appearance="default" [isRounded]="true">
        </lds-icon-button>
      </div>
    </lds-card>

    <!-- contacts -->
    <h4>Contact</h4>

    <lds-card [isClickable]="true" (click)="edit()">
      <div class="individual-display__details">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Home number"
              [text]="data.individual.contact?.homePhone"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-5">
            <app-summary-field
              label="Work number"
              [text]="data.individual.contact?.workPhone"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Mobile number"
              [text]="data.individual.contact?.mobile"></app-summary-field>
          </div>
          <div class="col-12 col-sm-9">
            <app-summary-field
              label="Email"
              [text]="data.individual.contact?.email"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <app-summary-field
              label="Preferred method"
              [text]="
                data.individual.contact?.preferredMethod
              "></app-summary-field>
          </div>
        </div>
      </div>
    </lds-card>

    <!-- addresses -->
    <h4>Addresses</h4>

    <lds-card [isClickable]="true" (click)="edit()">
      <div class="individual-display__details mb-md">
        <div *ngIf="data.individual.residences?.length > 0; else emptyList">
          <!-- TODO: responsive layout on small devices [future release] -->
          <div class="row">
            <div class="col-6">
              <div class="text-label">Address</div>
            </div>
            <div class="col">
              <div class="text-label">Residential status</div>
            </div>
            <div class="col">
              <div class="text-label">Type</div>
            </div>
          </div>

          <ng-container *ngFor="let address of data.individual.residences">
            <div class="row">
              <div class="col-6">
                <div class="text-data">
                  {{ address.address | agpSharedReadableAddress | summary }}
                </div>
              </div>
              <div class="col">
                <div class="text-data">{{ address.residentialStatus }}</div>
              </div>
              <div class="col">
                <div class="text-data">{{ address.addressType }}</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </lds-card>

    <!-- relationships -->
    <h4>Relationships</h4>

    <lds-card [isClickable]="true" (click)="edit()">
      <div class="individual-display__details mb-md">
        <div *ngIf="data.individual.relationships?.length > 0; else emptyList">
          <div class="row">
            <div class="col-6">
              <div class="text-label">Name</div>
            </div>
            <div class="col">
              <div class="text-label">Relation</div>
            </div>
          </div>
          <ng-container
            *ngFor="let relationship of data.individual.relationships">
            <div class="row">
              <div class="col-6">
                <div class="text-data">
                  {{ relationship.id | contactName : data.contacts }}
                </div>
              </div>
              <div class="col">
                <div class="text-data">{{ relationship.value }}</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </lds-card>

    <!-- dependents -->
    <h4>Dependents</h4>

    <lds-card [isClickable]="true" (click)="edit()">
      <div class="individual-display__details">
        <div *ngIf="data.individual.dependents?.length > 0; else emptyList">
            <div class="row">
              <div class="col-6">
                <div class="text-label">Name</div>
              </div>
              <div class="col">
                <div class="text-label">Age</div>
              </div>
            </div>
            <ng-container *ngFor="let dependent of data.individual.dependents">
              <div class="row">
                <div class="col-6">
                  <div class="text-data">{{ dependent.name }}</div>
                </div>
                <div class="col">
                  <div class="text-data">
                    {{ ageDisplay(dependent.birthDate) }}
                  </div>
                </div>
              </div>
            </ng-container>
        </div>
      </div>
    </lds-card>

    <ng-container *ngIf="displayFurtherDetails(data.individual)">
      <!-- other details -->
      <h4>Further details</h4>

      <lds-card [isClickable]="true" (click)="edit()">
        <div class="individual-display__details">
          <div class="row">
            <ng-container
              *ngIf="displayBooleanField(data.individual.permanentResident)">
              <div class="col-12 col-sm-6 col-lg-3">
                <app-summary-field
                  label="Permanent resident"
                  [text]="
                    data.individual.permanentResident | yesNo | titlecase
                  "></app-summary-field>
              </div>
            </ng-container>

            <ng-container *ngIf="displayBooleanField(data.individual.citizen)">
              <div class="col-12 col-sm-6 col-lg-3">
                <app-summary-field
                  [label]="citizenLabel"
                  [text]="
                    data.individual.citizen | yesNo | titlecase
                  "></app-summary-field>
              </div>
            </ng-container>

            <ng-container
              *ngIf="displayBooleanField(data.individual.repayingStudentLoan)">
              <div class="col-12 col-sm-6 col-lg-3">
                <app-summary-field
                  label="Repaying student loan"
                  [text]="
                    data.individual.repayingStudentLoan | yesNo | titlecase
                  "></app-summary-field>
              </div>
            </ng-container>
          </div>
        </div>
      </lds-card>
    </ng-container>

    <div class="tags-summary">
      <h4>Tags</h4>
      <lds-card>
        <div class="tags-summary__details">
          <app-tag-input
          [entityId]="individualId"
          [entityType]="TagEntityType.Individuals"
            [readonly]="false"
            [showLabel]="false">
          </app-tag-input>
        </div>
      </lds-card>
    </div>

    <h4>Referrer Arrangement</h4>

    <spark-contacts-referrer-arrangement-summary
      [referrerArrangement]="data.individual.referrerArrangement"
      (clicked)="edit()">
    </spark-contacts-referrer-arrangement-summary>
  </ng-container>
  <ng-template #emptyList>
    <p>None</p>
  </ng-template>
</div>
